import styled from '@emotion/styled';

export const ContentModuleSegment = styled.div`
  &:empty {
    display: none;
  }

  &:not(:empty) {
    padding-block: 2.5rem;
  }
`;
